/**
 * initLazyVideo()
 *
 * Implements lazy loading for HTML5 videos.
 * - Uses IntersectionObserver to detect when video is in viewport.
 * - Swaps data-src to src on source elements.
 * - Handles autoplay requirements (muted/playsinline).
 * - Adds a 'is-loaded' class when ready.
 */

export default function initLazyVideo() {
    const lazyVideos = document.querySelectorAll("video.lazy-video");

    if ("IntersectionObserver" in window) {
        const videoObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    loadVideo(video);
                    observer.unobserve(video);
                }
            });
        });

        lazyVideos.forEach((video) => {
            videoObserver.observe(video);
        });
    } else {
        // Fallback for older browsers
        lazyVideos.forEach((video) => {
            loadVideo(video);
        });
    }

    function loadVideo(video) {
        const sources = video.querySelectorAll("source");
        
        sources.forEach((source) => {
            if (source.dataset.src) {
                source.src = source.dataset.src;
            }
        });

        video.load();
        video.classList.add("is-loaded");

        // Handle Autoplay
        if (video.hasAttribute("data-autoplay")) {
            // Ensure muted/playsinline for mobile autoplay policy
            video.muted = true;
            video.setAttribute("playsinline", "");
            video.setAttribute("webkit-playsinline", "");
            
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch((error) => {
                    console.log("Autoplay prevented:", error);
                    // Show controls if autoplay fails so user can play manually
                    video.controls = true;
                });
            }
        }
    }
}
